import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableCustom, SearchBarBox, HeadlinePage } from 'components/common';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Paper } from '@mui/material';
import { useForm } from 'react-hook-form';
import { withPermission } from 'hoc'


const CompanyListDumb = ({
   handleSearch,
   searchValue,
   handleCreate,
   handleEdit,
   handleDelete,
   content,
   isLoaded,
   validPermission
 }) => {
  const methods = useForm();
  const projectId = methods.getValues('project');
  const [t] = useTranslation();

  const onSubmit = (data) => {
    handleSearch(data);
  };

  const onDelete = (project) => {
    handleDelete(project);
  };

  const onEdit = (project) => {
    handleEdit(project);
  };

  const createActions = () => {
    const actions = [];

    if (validPermission(projectId, 'isEdit')) actions.push({
      label: t('companyList.components.table.edit'),
      icon: <EditOutlinedIcon color="primary" />,
      handle: onEdit,
    });
    if (validPermission(projectId, 'isDelete')) actions.push({
      label: t('companyList.components.table.delete'),
      icon: <HighlightOffIcon color="primary" />,
      handle: onDelete,
    });

    return actions;
  }

  const columns = [
    { label: 'Name', key: 'name' },
  ];

  const actions = createActions();

  return (
    <>
      <HeadlinePage
        title="companyList.headline"
        buttonLabel={validPermission(projectId, "isCreate") ? "companyList.components.add" : ""}
        handleOnClick={handleCreate}
      />

      <SearchBarBox
        onSubmit={onSubmit}
        methods={methods}
        hideProject={true}
        searchValue={searchValue}
      />

      <Paper sx={{ p: 2 }}>
        <TableCustom
          title="companyList.components.titleList"
          columns={columns}
          content={content}
          actions={actions}
          loading={isLoaded}
          handleNotResults={handleCreate}
        />
      </Paper>
    </>
  )
}

export default withPermission(CompanyListDumb, 'companies');
